<div class="c-modal c-modal--md" id="modal-{{ vm.uid }}">
    <div mat-dialog-content class="c-modal__dialog">

        <div class="c-modal__header">
            <div class="o-grid">
                <div *ngIf="!vm.isTokenCorrupted"
                     class="o-grid__cell u-no-p">
                    <p class="u-mb-0" style="font-size: 22px" >
                        {{ (vm.isSyncInProgress ? 'Calendar.Title.Sync_Calendar_In_Progress_Title' : 'Calendar.Title.Selection_Title') | translate }}
                    </p>
                    <p class="u-mb-0" style="font-size: 16px; margin-top: 6px" >
                        {{ (vm.isSyncInProgress ? 'Calendar.Title.Sync_Calendar_In_Progress_Description' : 'Calendar.Title.Select_Calendar_Description') | translate }}
                    </p>
                </div>
                <div *ngIf="vm.isTokenCorrupted"
                     class="o-grid__cell u-no-p">
                    <p class="u-mb-0" style="font-size: 22px" >
                        {{ 'Calendar.Title.Broken_Token_Title' | translate }}
                    </p>
                    <p class="u-mb-0" style="font-size: 16px; margin-top: 6px" >
                        {{ 'Calendar.Title.Broken_Token_Description' | translate }}
                    </p>
                </div>
                <div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
                    <button
                            id="closeButton"
                            class="c-button c-button--icon c-button--tp c-modal__close"
                            (click)="vm.close()">
                        <i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
                        <span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
                    </button>
                </div>
            </div>
        </div>

        <div class="c-modal__content u-no-pt">
            <div class="c-card c-card--height-fit" style="box-shadow: none;">

                <form *ngIf="!vm.isTokenCorrupted" name="vm.form" class="c-form u-ost-md">

                    <div class="o-grid__cell o-grid__cell--w-100 u-no-p">

                        <div class="c-form__group u-osb-lg">
                            <label for="select-google-calendar" class="c-form__label c-form__label--light">{{ 'Calendar.Title.Select_Calendar' | translate }}</label>
                            <mat-select id="select-google-calendar"
                                        name="select-google-calendar"
                                        [(value)]="vm.modifiedSelectedCalendar"
                                        (selectionChange)="onCalendarChanged($event)"
                                        class="mat-select mat-select--sm mat-select--border">
                                <mat-option *ngFor="let calendar of vm.calendars ; let $index=index" [value]="calendar">
                                    {{ calendar.primary ? ('Calendar.Title.Main_Calendar' | translate) : calendar.title }}
                                </mat-option>
                            </mat-select>
                        </div>

                    </div>

                </form>

                <div *ngIf="!vm.isTokenCorrupted"  class="c-modal__content u-ost-sm">
                    <div class="o-grid o-grid--wrap o-grid--xs o-grid--left">
                        <div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-100 u-ost-xs u-osb-xs">
                            <p class="u-mb-0" style="font-size: 16px; margin: 0 0 16px 0" >
                                {{ 'Calendar.Title.Sync_Calendar_Exclusions_Description' | translate }}:
                            </p>
                            <div *ngFor="let nonSelectedCalendar of vm.nonSelectedCalendars ; let $index=index">
                                <mat-checkbox [(ngModel)]="nonSelectedCalendar.excluded">
                                    {{ nonSelectedCalendar.primary ? ('Calendar.Title.Main_Calendar' | translate) : nonSelectedCalendar.title }}
                                </mat-checkbox>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="c-modal__footer u-ost-sm">
                    <div class="o-grid o-grid--wrap o-grid--xs o-grid--right">
                        <div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-50 u-ost-xs u-osb-xs" >
                            <button id="disableIntegrationButton"
                                    class="c-button c-button--fit c-button--narrow c-button--s13"
                                    (click)="vm.disableIntegration()">
                                {{ 'Calendar.Button.Disable_Google_Calendar_Integration' | translate }}
                            </button>
                        </div>
                        <div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-50 u-ost-xs u-osb-xs" >
                            <button id="synchronizeNowButton"
                                    class="c-button c-button--fit c-button--narrow c-button--s6"
                                    [disabled]="!vm.modifiedSelectedCalendar || vm.selectedCalendar?.id !== vm.modifiedSelectedCalendar?.id"
                                    (click)="vm.synchronizeNow()">
                                {{ 'Calendar.Title.Synchronize' | translate }}
                            </button>
                        </div>
                        <div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-100 u-ost-xs u-osb-xs" >
                            <button id="saveChangesButton"
                                    class="c-button c-button--fit c-button--narrow c-button--s1"
                                    [disabled]="vm.isTokenCorrupted"
                                    (click)="vm.saveChanges()">
                                {{ 'Calendar.Button.Save' | translate }}
                            </button>
                        </div>
                    </div>
                </div>

                <loader-overlay *ngIf="vm.processing || !this.vm.initialized"></loader-overlay>

            </div>
        </div>

    </div>
</div>
